import { useMutation } from "@tanstack/react-query"
import { Button } from "components"
import CustomModal from "components/new-stuff/ui/modals/CustomModal"
import React from "react"
import { useAppNotificationStore } from "stores"
import { onQueryError } from "utils/utils"

const DeleteSurvey = ({
  title,
  description,
  deleteFn,
  open,
  onClose,
  activeDeleteId,
  invalidateQueries,
}: {
  title: string
  description: string
  deleteFn: (id: string) => Promise<any>
  open: boolean
  onClose: () => void
  invalidateQueries: () => void
  activeDeleteId: string
}) => {
  const { toast } = useAppNotificationStore()
  const { isLoading: isSubmittingDelete, mutate: submitDelete } = useMutation({
    mutationFn: async () => deleteFn(activeDeleteId),
    onSuccess: (data: any) => {
      onClose()
      invalidateQueries()
      data?.message && toast.success(data.message)
    },
    onError: onQueryError,
  })
  const handleDelete = () => {
    submitDelete()
  }
  return (
    <CustomModal
      title={title}
      onCancel={onClose}
      open={open}
    >
      <div className=" flex flex-col ">
        <p className="text-[#15294B] text-sm  mb-6">{description}</p>
      </div>
      <div className=" items-center flex gap-4  justify-end ">
        <Button
          color="secondary"
          onClick={() => {
            onClose()
          }}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          submitting={isSubmittingDelete}
          onClick={() => {
            handleDelete()
          }}
        >
          Confirm
        </Button>
      </div>
    </CustomModal>
  )
}

export default DeleteSurvey
